import { useCallback, useEffect, useState } from 'react';
import { env } from '@sib/config';
import axios from 'axios';
import qs from 'qs';

const MAX_RETRIES = 4;
const VERSION_CHECK_INTERVAL = 1000 * 60 * 5; // 5 minutes

export const useSpendbrainVersionCheck = () => {
  const [isNewVersionAvailable, setIsNewVersionAvailable] = useState(false);
  const [retriesCount, setRetriesCount] = useState(0);
  const currentVersion = env.spendbrainVersion;

  const onAppReload = useCallback(() => {
    window.location.href = `${window.location.href}${qs.stringify({ reload: Date.now() }, { addQueryPrefix: true })}`;
  }, []);

  const getStaticVersion = useCallback(async () => {
    try {
      const response = await axios.get(
        `/version.json${qs.stringify(
          {
            ts: Date.now(),
          },
          { addQueryPrefix: true }
        )}`,
        {
          headers: { 'Cache-Control': 'no-store' },
        }
      );

      return response.data;
    } catch (error) {
      return error;
    }
  }, []);

  useEffect(() => {
    const checkVersion = async () => {
      const staticVersion = await getStaticVersion();
      if (currentVersion !== staticVersion) {
        if (retriesCount >= MAX_RETRIES) {
          setRetriesCount(0);

          return setIsNewVersionAvailable(true);
        }
        setRetriesCount(prevCount => prevCount + 1);
      }
    };

    const interval = setInterval(checkVersion, VERSION_CHECK_INTERVAL);

    return () => clearInterval(interval);
  }, [getStaticVersion, currentVersion, retriesCount]);

  return {
    isNewVersionAvailable,
    onAppReload,
  };
};
